import { render, staticRenderFns } from "./BodyShopEmail.vue?vue&type=template&id=423e7c79"
import script from "./BodyShopEmail.vue?vue&type=script&lang=js"
export * from "./BodyShopEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports